import React from "react";

const Footer = () => {
  return (
    <div className="footerCompoent flex flex-row justify-between w-full py-[6px] px-10 bg-white border-t border-black/20">
      <span className="flex text-primary text-[10px]">
        © 2022 Insight africa, Tous droits réservés
      </span>
      <div className="flex text-[10px] gap-1">
        <span className="flex">Developpe par</span>
        <a
          href="http://www.awanze.com"
          target="_blank"
          className="flex text-primary font-semibold"
          rel="noreferrer"
        >
          Awanze
        </a>
      </div>
    </div>
  );
};

export default Footer;
